import { render, staticRenderFns } from "./Select2.vue?vue&type=template&id=7287d3d6&scoped=true&"
import script from "./Select2.vue?vue&type=script&lang=js&"
export * from "./Select2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7287d3d6",
  null
  
)

export default component.exports